import React from "react";

function FaceBookIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 42 42"
        >
            <circle cx="21" cy="21" r="21" fill="#4B68AC"></circle>
            <path
                fill="#fff"
                d="M18.058 29h3.913v-8.578h2.732l.297-2.87h-3.029v-1.631c0-.684.149-.943.9-.943H25V12h-2.724c-2.919 0-4.233 1.12-4.233 3.265v2.295H16v2.902h2.043L18.058 29z"
            ></path>
        </svg>
    );
}

export default FaceBookIcon;
